import * as actionTypes from './actionTypes';

export const userLogin = (value) => {
    return {
        type: actionTypes.USER_LOGIN,
        userLoggedInStatus: value
    }
}

export const userLogout = (value) => {
    return {
        type: actionTypes.USER_LOGOUT,
        userLoggedInStatus: value
    }
}

export const setTopbarTheme = (theme) => {
    return {
        type: actionTypes.SET_TOPBAR_THEME,
        theme: theme
    }
}

export const openSignInModal = (value) => {
    return {
        type: actionTypes.OPEN_SIGN_IN_MODAL,
        value: value
    }
}

export const openForgotPasswordModal = (value) => {
    return {
        type: actionTypes.OPEN_FORGOT_PASSWORD_MODAL,
        value: value
    }
}

export const setBasicUserDetails = (data) => {
    return {
        type: actionTypes.SET_BASIC_USER_DETAILS,
        userDetails: data
    }
}

export const setInitialProgramData = (continueLearningData, ongoingProgram, enrolledPrograms) => {
    return {
        type: actionTypes.SET_INITIAL_PROGRAM_DATA,
        continueLearningData: continueLearningData,
        ongoingProgramData: ongoingProgram,
        enrolledProgramsData: enrolledPrograms
    }
}

export const setInitialModuleData = (moduleOverviewData, ongoingModule, enrolledModules) => {
    return {
        type: actionTypes.SET_INITIAL_MODULE_DATA,
        moduleOverviewData: moduleOverviewData,
        ongoingModuleData: ongoingModule,
        enrolledModules: enrolledModules
    }
}

export const setContinueLearningData = (data) => {
    return {
        type: actionTypes.SET_CONTINUE_LEARNING_DATA,
        continueLearningData: data
    }
}

export const setOngoingProgramData = (data) => {
    return {
        type: actionTypes.SET_ONGOING_PROGRAM_DATA,
        ongoingProgramData: data
    }
}

export const setEnrolledProgramsData = (data) => {
    return {
        type: actionTypes.SET_ENROLLED_PROGRAMS_DATA,
        enrolledProgramsData: data
    }
}

export const setActiveProgramId = (data) => {
    return {
        type: actionTypes.SET_ACTIVE_PROGRAM_ID,
        programId: data.id,
        programBatchCode: data.batchCode,
        programType: data.type
    }
}

export const setActiveModuleId = (data) => {
    return {
        type: actionTypes.SET_ACTIVE_MODULE_ID,
        moduleId: data.id,
        batchCode: data.batchCode,
        moduleName: data.moduleName
    }
}

export const setUnreadNotifCount = (count) => {
    return {
        type: actionTypes.SET_UNREAD_NOTIF_COUNT,
        updatedCount: count
    }
}

export const setupProgramDetailsTopbar = (showTopbar, showProgramProgress, showModuleProgress, hideTopbar) => {
    return {
        type: actionTypes.SETUP_PROGRAM_DETAILS_TOPBAR,
        showTopbar: showTopbar,
        showProgramProgress: showProgramProgress,
        showModuleProgress: showModuleProgress,
        hideTopbar: hideTopbar
    }
}

export const onFailureDialogShow = (msg, btnLabel) => {
    return {
        type: actionTypes.ON_FAILURE_DIALOG_SHOW,
        message: msg,
        buttonLabel: btnLabel
    }
}

export const onFailureDialogHide = () => {
    return {
        type: actionTypes.ON_FAILURE_DIALOG_HIDE,
        message: '',
        buttonLabel: ''
    }
}

export const onSuccessDialogShow = (msg, btnLabel) => {
    return {
        type: actionTypes.ON_SUCCESS_DIALOG_SHOW,
        message: msg,
        buttonLabel: btnLabel
    }
}

export const onSuccessDialogHide = () => {
    return {
        type: actionTypes.ON_SUCCESS_DIALOG_HIDE,
        message: '',
        buttonLabel: ''
    }
}

export const redirectToUnauthorized = () => {
    return {
        type: actionTypes.REDIRECT_TO_UNAUTHORIZED
    }
}

export const redirectToNotFound = () => {
    return {
        type: actionTypes.REDIRECT_TO_NOT_FOUND
    }
}

export const redirectToServerError = () => {
    return {
        type: actionTypes.REDIRECT_TO_SERVER_ERROR
    }
}

export const showQuizNavbar = (status) => {
    return {
        type: actionTypes.SHOW_QUIZ_NAVBAR,
        showStatus: status
    }
}

export const onProfilePicUpdated = () => {
    return {
        type: actionTypes.ON_PROFILE_PIC_UPDATED
    }
}

export const resetAllErrorPages = () => {
    return {
        type: actionTypes.RESET_ALL_ERROR_PAGES
    }
}

export const updateLeanerLiveSessionStatus = (liveSessionStatus, liveSessionData) => {
    return {
        type: actionTypes.UPDATE_LEARNER_LIVE_SESSION_STATUS,
        liveSessionStatus: liveSessionStatus,
        liveSessionData: liveSessionData
    }
}

export const showSessionExpiredDialog = (showStatus) => {
    return {
        type: actionTypes.SHOW_SESSION_EXPIRED_DIALOG,
        showStatus: showStatus
    }
}

export const redirectToHome = (status) => {
    return {
        type: actionTypes.REDIRECT_TO_HOME,
        status: status
    }
}

export const hideTopbarStrip = (status) => {
    return {
        type: actionTypes.SET_TOPBAR_STRIP_STATUS,
        status: status
    }
}